// extracted by mini-css-extract-plugin
module.exports = {"prevComponent":"styles_prevComponent__29_Xx","nextComponent":"styles_nextComponent__NWKDt"};